import { create, el } from "@dhx/ts-common/dom";
import { IEventSystem, EventSystem } from "@dhx/ts-common/events";
import { View } from "@dhx/ts-common/view";
import { getFormItemCss, getValidationMessage } from "../helper";
import { Popup } from "@dhx/ts-popup";
import { ValidationStatus, IRadioButton } from "../types";

export enum RadioButtonEvents {
	change = "change"
}

export class RadioButton extends View {
	public config: IRadioButton;
	public events: IEventSystem<RadioButtonEvents>;
	protected _handlers: any;
	protected _helper: Popup;

	constructor(container: HTMLElement | string, config = {}) {
		super(container, config);
		if (this.config.help) {
			this._helper = new Popup({css: "dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"});
			this._helper.attachHTML(this.config.help);
		}
		this._handlers = {
			showHelper: e => {
				e.preventDefault();
				e.stopPropagation();
				this._helper.show(e.target);
			},
			cancelUnusefulClick: e => {
				e.preventDefault();
			},
			onchange: (e: Event) => {
				this.config.checked = (e.target as HTMLInputElement).checked;
				this.events.fire(RadioButtonEvents.change, [(e.target as HTMLInputElement).checked]);
			}
		};
		this.events = new EventSystem();

		const render = () => this._draw();
		this.mount(container, create({ render }));
	}
	clearValidate(): void {
		this.config.$validationStatus = ValidationStatus.pre;
		this.paint();
	}
	clear(): void {
		this.config.checked = false;
		this.paint();
	}
	getValue(): string | void {
		if (this.config.checked) {
			return this.config.value;
		}
	}
	setValue(checked: boolean): void {
		this.config.checked = checked;
		this.paint();
	}
	destructor(): void {
		this._helper.destructor();
		this.events.clear();
		this.unmount();
	}
	private _draw() {
		const { id, value, label, checked, disabled, name, help, labelWidth, labelInline, required } = this.config;
		return el("label.dhx_radiobutton.dhx_form-group", {
			class: getFormItemCss(this.config, Boolean(required)),
			style: {"margin-left": `${labelWidth && labelInline ? `calc(${labelWidth} + 16px)` : ""}`}
		}, [
			el("input.dhx_radiobutton__input", {
				type: "radio",
				id,
				value: value || "",
				name: name || "",
				disabled,
				checked,
				onchange: this._handlers.onchange,
				required
			}),
			el("span.dhx_radiobutton__visual-input"),
			el("span.dhx_label", {
				class: help ? "dhx_label--with-help" : ""
			}, help ? [
				el("span.dhx_label__holder", label),
				el("span.dhx_label-help.dxi.dxi-help-circle-outline", {
					tabindex: "0",
					role: "button",
					onclick: this._handlers.showHelper
				}),
			] : label), el("span.dhx_input__caption", {
				onclick: this._handlers.cancelUnusefulClick,
			}, getValidationMessage(this.config)),
		]);
	}
}